// ============================================================
//  src/moderacion.js — Eventos de moderación y solicitudes admin
// ============================================================

import { collection, addDoc, getDocs, query, where, serverTimestamp, updateDoc, doc } from 'firebase/firestore';
import { db } from './firebase.js';

// ============================================================
//  Moderación de archivos
// ============================================================

/**
 * Retorna true si ya existe una moderación activa (pendiente o aprobada)
 * para el mismo tipo + concurso + año + modo, sin importar la edición.
 * Una moderación rechazada NO bloquea la creación de una nueva.
 */
export async function yaExisteModeracion(tipo, concurso, año, modo) {
  const q = query(
    collection(db, 'moderacionArchivos'),
    where('tipo',     '==', tipo),
    where('concurso', '==', concurso),
    where('año',      '==', año),
    where('modo',     '==', modo)
  );
  const snap = await getDocs(q);
  return snap.docs.some(d => d.data().estado !== 'rechazado');
}

export async function crearEventoModeracion({ edicionId, archivoId, tipo, concurso, año, modo, subidoPor }) {
  await addDoc(collection(db, 'moderacionArchivos'), {
    edicionId,
    archivoId,
    tipo,
    concurso,
    año,
    modo,
    subidoPor,
    estado:      'pendiente',
    subidoEn:    serverTimestamp(),
    revisadoPor: null,
    revisadoEn:  null,
  });
}

// ============================================================
//  Solicitudes admin
// ============================================================

export async function solicitarCambioStorage(uid, from, to) {
  const col = collection(db, 'solicitudesCambioStorage');
  await addDoc(col, {
    uid,
    from,
    to,
    createdAt: serverTimestamp(),
    status:    'pendiente',
  });
}

export async function solicitarAccesoManagedDrive(uid, displayName, email) {
  const col = collection(db, 'solicitudesManagedDrive');
  await addDoc(col, {
    uid,
    displayName: displayName || '',
    email:       email       || '',
    solicitadoEn: serverTimestamp(),
    estado:      'pendiente',
  });
}

export async function yaExisteSolicitudManagedDrive(uid) {
  const q = query(
    collection(db, 'solicitudesManagedDrive'),
    where('uid', '==', uid),
    where('estado', '==', 'pendiente')
  );
  const snap = await getDocs(q);
  return !snap.empty;
}

export async function cancelarSolicitudManagedDrive(uid) {
  const q = query(
    collection(db, 'solicitudesManagedDrive'),
    where('uid', '==', uid),
    where('estado', '==', 'pendiente')
  );
  const snap = await getDocs(q);
  await Promise.all(snap.docs.map(d =>
    updateDoc(doc(db, 'solicitudesManagedDrive', d.id), {
      estado:      'cancelada',
      canceladaEn: serverTimestamp(),
    })
  ));
}
